<template>
  <a @click="toPath()" class="my-content" :title="title">
    <div class="icon-text">
      <img v-if="beforeSrc" :src="beforeSrc" alt="Icon" style="margin-right: 10px"> <!-- 使用 img 标签加载图片 -->
      <div class="n-line" :style="{width: createtime? 'calc(100% - 81px)': 'calc(100% - 20px)'}">{{title}}</div>
      <div class="n-time" v-if="createtime">{{createtime}}</div>
    </div>
    <div v-if="showBottom"
         style="height: 3px;margin-bottom: 5px; border-bottom: 1px dashed #aaa; width: calc(100% - 6px); margin-left: 0px "></div>
  </a>
</template>

<script>
export default {
  name: "normal-article",
  props: {
    createtime: {
      type: String,
      // default: '2024-11-25'
    },
    title: {
      type: String,
      default: ''
    },
    id: {},
    showBottom: {
      type: Boolean,
      default: true
    },
    beforeSrc: {
      default: ''
    },
    path: {

    }
  },
  methods: {
    toPath() {
      if(this.path) {
        this.$router.push({
          path: this.path
        })
      }
      else if(this.id) {
        this.$router.push({
          path: '/article-page/'+this.id
        })
      }
    }
  }
}
</script>

<style scoped>
.icon-text {
  display: flex;
  align-items: center;
  width: calc(100%); /* 可根据需要调整最大宽度 */
  font-size: 14px;
  line-height: 25px;

}

.n-line {
  width: calc(100% - 81px);
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  /*word-break: break-all;*/
  cursor: pointer;
  line-height: 30px;
}
.my-content:hover .n-line,
.my-content:hover .n-time
{
  color: #0f6ee2;
  cursor: pointer;
}
.n-line:hover {
  color: #0f6ee2;
}
.n-time{
  width: 100px;
  margin-left: 10px;
  color: #999;
}
</style>
